import { render } from "./SocialFeed.vue?vue&type=template&id=b21fbe1e&scoped=true"
import script from "./SocialFeed.vue?vue&type=script&lang=ts"
export * from "./SocialFeed.vue?vue&type=script&lang=ts"

import "./SocialFeed.vue?vue&type=style&index=0&id=b21fbe1e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b21fbe1e"

export default script